import * as I18n from 'i18n-js';
import * as React from 'react';
import HomepageCategories from '../homepage_categories';
import RQLHomepageFeed from '../../../feed/rql_homepage_feed';
import RegionalListings from '../regional_listings';
import HomepageCuratedSetRow from '../homepage_curated_set_row';
import HomepageBumpedListingsContainer from './homepage_bumped_listings_container';
import HomepageBumpedListings from './homepage_bumped_listings';
import { Paths } from '../../shared/url_helpers';
import DownloadAppCallout from './download_app_callout';
import HomepageSell from './homepage_sell';
import HomepageNewsletter from './homepage_newsletter';
import RecentArticles from './recent_articles';
import { buyingGuideEligibleRegionAndLocale } from '../user_helper';
import { US_CON_CODE } from '../../shared/constants';
import experiments from '@reverbdotcom/commons/dist/experiments';
import RecentlyViewedCspsRow from '../../recently_viewed_csps_row';

import CmsListingsCollection from '@reverbdotcom/commons/dist/cms/components/cms_listings_collection';
import CmsPageCards from '@reverbdotcom/commons/dist/cms/components/cms_page_cards';
import RecentlyViewedListings from '@reverbdotcom/commons/dist/cms/components/recently_viewed_listings';
import WatchedListings from '@reverbdotcom/commons/dist/components/watched_listings';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import CmsEmbed from '@reverbdotcom/commons/dist/components/cms_embed';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

export class LoggedInHomepage extends React.Component<IUserContext, any> {
  renderBuyingGuides() {
    if (buyingGuideEligibleRegionAndLocale(this.props.user.shippingRegionCode, this.props.user.locale)) {
      return (
        <div className="homepage-container__component-wrapper">
          <CmsPageCards
            title={I18n.t('discovery.homepage.buyingGuides.buyingGuidesHeading')}
            pageFields={[
              { slug: 'buying-guide-acoustic-guitars' },
              { slug: 'buying-guide-telecasters' },
              { slug: 'buying-guide-audio-interfaces' },
              { slug: 'buying-guide-gibson-les-pauls' },
              { slug: 'buying-guide-affordable-monosynths' },
              { slug: 'buying-guide-reverb-pedals' },
            ]}
            ssr={false}
            action={this.renderBuyingGuidesAction()}
          />
        </div>
      );
    }

    return <HomepageCategories />;
  }

  renderBuyingGuidesAction() {
    return (
      <CoreLink to={Paths.buyingGuide.expand({})}>
        {I18n.t('discovery.homepage.buyingGuides.seeMore')}
      </CoreLink>
    );
  }

  renderArticlesAction() {
    return (
      <CoreLink to={Paths.articlesSearch.expand({})}>
        {I18n.t('discovery.homepage.buyingGuides.seeMore')}
      </CoreLink>
    );
  }

  showPersonalizedBumpRow() {
    return isExperimentEnabled(this.props.user, experiments.LOGGED_IN_HOMEPAGE_PERSONALIZED_BUMP_ROW);
  }

  render() {
    return (
      <div className="homepage-container bg-white pt-half">
        <div className="homepage-container__component-wrapper">
          <RecentlyViewedCspsRow />
        </div>
        <div className="homepage-container__component-wrapper">
          <RecentlyViewedListings
            title={I18n.t('discovery.recentlyViewed.title')}
            largeTiles
            ctaTargetHref="/browsing_history"
          />
        </div>
        {this.showPersonalizedBumpRow() &&
          <div className="homepage-container__component-wrapper">
            <HomepageBumpedListingsContainer />
          </div>
        }
        <div className="homepage-container__component-wrapper">
          <WatchedListings />
        </div>
        <RQLHomepageFeed />
        <div className="homepage-container__component-wrapper">
          <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
        </div>
        <div className="homepage-container__component-wrapper">
          <RecentArticles
            action={this.renderArticlesAction()}
          />
        </div>
        {this.props.user.shippingRegionCode === US_CON_CODE &&
          <div className="homepage-container__component-wrapper">
            <HomepageCuratedSetRow />
          </div>
        }
        {this.renderBuyingGuides()}
        <div className="homepage-container__component-wrapper">
          <HomepageNewsletter signupReason="loggedinhomepage" />
        </div>
        <RegionalListings />
        <div className="homepage-container__component-wrapper">
          <CmsListingsCollection
            componentName="HomepageLatestListings"
            ctaTargetHref="/marketplace?condition=used"
            conditionSlugs={['used']}
            title={I18n.t('discovery.homepage.newestListings.title')}
            userShippingRegion={this.props.user.shippingRegionCode}
            maxCount={12}
            largeTiles
            ssr={false}
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <CmsListingsCollection
            curatedSetId="8"
            componentName="HomepageDealsAndSteals"
            ctaTargetHref="/promo/deals-and-steals"
            title={I18n.t('discovery.categoryNavBar.explore.deals')}
            maxCount={12}
            largeTiles
            ssr={false}
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <HomepageSell />
        </div>
        {!this.showPersonalizedBumpRow() &&
          <div className="homepage-container__component-wrapper">
            <HomepageBumpedListings />
          </div>
        }
        <div className="scaling-mt-7">
          <DownloadAppCallout />
        </div>
      </div>
    );
  }
}

export default withUserContext(LoggedInHomepage);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/logged_in.tsx